/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';

import CodeEditorPanel from './CodeEditorPanel/CodeEditorPanel';
import CodeResult from './CodeResult/CodeResult';

import { CodeEditorOptions, getEditorsNumber } from './codeEditor.helper';
import { createUserCodeTask } from '../../../api/apis';
import SavedLinkCopy from './SavedLinkCopy';
// import JSResults from './JSResult/JSResult';
// eslint-disable-next-line import/no-named-as-default
// import JSCodeResult from './CodeResult/JSCodeResult';
import './CodeEditorLayout.scss';
import CodeEditorFiles from './CodeEditorTypes/CodeEditorFiles';
import PostToCommentModal from './PostToCommentModal';
import paths from '../../../lib/consts/paths';

const CodeEditorLayoutWithFiles = ({
	field,
	wrapperField,
	taskSlug,
	parentField,
	pageView,
	backButton,
	taskId,
}) => {
	const defaults = {
		html: field?.options?.html || ' ',
		css: field?.options?.css || '',
		scss: field?.options?.scss || '',
		js: field?.options?.js || '',
		jsTests: field?.options?.jsTests || '',
	};

	const navigate = useNavigate();
	const [codeValue, setCodeValue] = useState(defaults);
	// const [jsCodeValue, setJsCodeValue] = useState('');
	const [jsResults, setJsResults] = useState(null);
	const [isHorizontalView, setIsHorizontalView] = useState(false);
	const [isResetting, setIsResetting] = useState(false);
	const [isExpanded, setIsExpanded] = useState(false);
	const [userSavedCodeTask, setUserSavedCodeTask] = useState('');
	// const [copySavedLinkCounter, setCopySavedLinkCounter] = useState(0);
	// const [postToCommentCounter, setPostToCommentCounter] = useState(0);
	const [openLinkCopyModal, setOpenLinkCopyModal] = useState(false);
	const [openPostToCommentModal, setOpenPostToCommentModal] = useState(false);

	const isJsEditor = false;

	// For JS and JS_TESTS editors only
	/* const initWorker = () =>
		React.useMemo(
			() => new Worker(new URL('./JSCodeEvaluator.worker.js', import.meta.url)),
			[],
		);
	const worker = isJsEditor ? initWorker() : null; */

	// const jsIframe = React.useMemo(
	// 	() => (
	// 		<div className="code-result">
	// 			<JSCodeResult
	// 				code={jsCodeValue}
	// 				field={field}
	// 				isHorizontalView={isHorizontalView}
	// 				isExpanded={isExpanded}
	// 				editorsNumber={getEditorsNumber(field, CodeEditorOptions)}
	// 				hideIframe
	// 				name={parentField.name}
	// 			/>
	// 		</div>
	// 	),
	// 	[jsCodeValue],
	// );

	const codeRef = useRef(defaults);

	const createUserCodeTaskMutation = useMutation((data) =>
		createUserCodeTask(data),
	);

	const onReset = () => {
		setIsResetting(true);
		setCodeValue(defaults);
		codeRef.current = defaults;
	};

	useEffect(() => {
		onReset();
	}, [taskSlug]);

	useEffect(() => {
		if (field?.options?.js) {
			/* worker.onmessage = (workerResponse) => {
				setJsResults(workerResponse.data);
				return () => worker.terminate();
			}; */
			window.addEventListener('message', (e) => {
				const { data } = e;
				if (
					data &&
					data.source &&
					data.source === `__cwt__jstests__${parentField.name}`
				) {
					console.log('message: ', e, data);
					setJsResults(data.payload);
				}
			});
		} else {
			onReset();
		}
	}, []);

	const changeView = () => {
		// TODO: add Files view
		// TODO: make it resizable https://stackoverflow.com/questions/47017753/monaco-editor-dynamically-resizable
		setIsHorizontalView(!isHorizontalView);
	};

	const runCode = async () => {
		const code = codeRef.current;
		if (isJsEditor) {
			/* worker.postMessage({
				code: code.js,
				tests: field?.options?.jsTests,
			}); */
			// setJsCodeValue(code.js);
		} else {
			setCodeValue(code);
		}
	};
	const saveLink = (callback) => {
		const code = codeRef.current;
		const payload = {
			code: {
				value: field.value,
				options: { ...code },
			},
			name: wrapperField.name || 'custom',
			original: wrapperField.id,
		};
		createUserCodeTaskMutation.mutate(payload, {
			onSuccess(createdCodeTask) {
				setUserSavedCodeTask(createdCodeTask.slug);
				callback();
			},
		});
	};

	const onSave = () => {
		const callback = () => {
			setOpenLinkCopyModal(true);
		};
		saveLink(callback);
	};

	const handleGoBack = () => {
		if (backButton) {
			window.history.back();
		} else {
			navigate(paths.courses);
		}
	};

	useEffect(() => {
		if (isResetting) {
			setIsResetting(false);
			runCode();
		}
	}, [isResetting]);

	useEffect(() => {
		if (pageView) {
			setIsExpanded(!isExpanded);
		}
	}, [pageView]);

	const onEditorChange = (code) => {
		codeRef.current = code;
	};

	const wrapperClasses = classNames('CodeEditorLayout', {
		horizontal: isHorizontalView,
		vertical: !isHorizontalView,
		expanded: isExpanded,
	});

	const postToComments = () => {
		const callback = () => {
			setOpenPostToCommentModal(true);
		};
		saveLink(callback);
	};

	return (
		<div className={wrapperClasses}>
			<CodeEditorPanel
				theme="white"
				runCode={runCode}
				changeView={changeView}
				reset={onReset}
				expand={() => setIsExpanded(!isExpanded)}
				save={onSave}
				handleGoBack={handleGoBack}
				pageView={pageView}
				backButton={backButton}
				postToComments={postToComments}
			/>
			<div className="code-editor-inner-layout">
				{!isResetting && (
					<CodeEditorFiles
						onEditorChange={onEditorChange}
						field={field}
						isHorizontalView={isHorizontalView}
						isExpanded={isExpanded}
					/>
				)}

				{!isJsEditor && (
					<div className="code-result">
						<CodeResult
							code={codeValue}
							isHorizontalView={isHorizontalView}
							isExpanded={isExpanded}
							editorsNumber={getEditorsNumber(field, CodeEditorOptions)}
							field={parentField}
							jsResults={jsResults}
							isCodeEditorWithFiles
						/>
					</div>
				)}
				{/* {isJsEditor && (
					<div>
						{jsIframe}
						<JSResults evaluatedResult={jsResults} />
					</div>
				)} */}
				{/* {isJsEditor && (
					<div className="code-result">
						<div className="CodeResult">
							<CodeEditorHeader name="Result" theme="dark" />
							<JSResults evaluatedResult={jsResults} />
						</div>
					</div>
				)} */}
			</div>
			<SavedLinkCopy
				codeTaskId={userSavedCodeTask}
				open={openLinkCopyModal}
				onClose={() => {
					setOpenLinkCopyModal(false);
				}}
			/>
			{taskId && (
				<PostToCommentModal
					codeTaskId={userSavedCodeTask}
					taskId={taskId}
					open={openPostToCommentModal}
					onClose={() => {
						setOpenPostToCommentModal(false);
					}}
				/>
			)}
		</div>
	);
};

export default CodeEditorLayoutWithFiles;
